import baseService from "./baseService"

const userDataService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getUserAttributes: build.query({
      query: () => ({
        method: "GET",
        url: "/api/users/me",
      }),
      providesTags: ["UserData"],
    }),
    getUserRoles: build.query({
      query: () => ({
        method: "GET",
        url: "/api/user-roles/user-roles",
        normaliseResponse: false,
      }),
      providesTags: ["UserData"],
    }),
  }),
})

export const { useGetUserAttributesQuery, useGetUserRolesQuery } = userDataService

export default userDataService
